import styled from 'astroturf/react'
import { useSelector } from 'react-redux'
import { ArrowRightIcon } from '@calendly/ui/components/icons'
import { Link } from '@calendly/ui/components/link'

import { eventTypePathSelector } from 'selectors/url'
import { eventTypeSelector, purchasedPackageSelector } from 'root-api'
import _Wrapper from "links-Wrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/links.js?styleId=Wrapper";


const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper
})


export const Links = () => {
  const {
    show_custom_links: showCustomLinks,
    custom_links: customLinks,
    another_event_button_enabled: anotherButtonEnabled,
    another_event_button_content: anotherButtonContent,
    confirmation_page_type: confirmationPageType,
  } = useSelector(eventTypeSelector)

  const purchasedPackage = useSelector(purchasedPackageSelector)
  const bookingPath = useSelector(eventTypePathSelector)

  if (confirmationPageType === 'external') return null

  if (!anotherButtonEnabled && !customLinks.length) return null

  return (
    <Wrapper data-container="custom-links">
      {
        anotherButtonEnabled && !purchasedPackage && (
          <Link underline={false} href={bookingPath} target="_self" rel="opener">
            <ArrowRightIcon inline />
            {anotherButtonContent}
          </Link>
        )
      }
      {showCustomLinks && customLinks.map(({ id, url, content }) => (
        <Link underline={false} key={id} href={url} target="_blank" rel="noopener noreferrer">
          <ArrowRightIcon inline />
          {content}
        </Link>
      ))}
    </Wrapper>
  )
}
